var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanoeSlalom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 30.9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,22.1l-14.6,14.6c-2.1,2.1-2.6,5.6-3.1,8.9c-0.4,2.9-0.8,5.9-2.3,7.4l-7,7c-0.7-0.4-1.6-0.7-2.5-0.7h-21L51,38.9 c-3.5-3.5-9.2-3.5-12.7,0l-22,22L0,44.7v3.8l53.2,53.2l-0.4,0.4l0,0l0,0c-1.5,1.5-4.5,1.9-7.4,2.3c-3.3,0.5-6.8,1-8.9,3.1 l-14.6,14.6L34.7,135l14.6-14.6c2.1-2.1,2.6-5.6,3.1-8.9c0.4-2.9,0.8-5.9,2.3-7.4l0.4-0.4L95.4,144h3.8l-42.2-42.2l7.1-7.1 c2,1.1,4.5,0.8,6.2-0.8c1.7-1.7,1.9-4.2,0.8-6.2l18-18h3.2c2.8,0,5.1-2.3,5.1-5.1c0-0.9-0.2-1.8-0.7-2.5l7-7l0,0 c1.5-1.5,4.5-1.9,7.4-2.3c3.3-0.5,6.8-1,8.9-3.1l14.6-14.6L122,22.1z M49.8,111.1c-0.4,2.9-0.8,5.9-2.3,7.4l-12.7,12.7l-9-9 l12.7-12.7c1.5-1.5,4.5-1.9,7.4-2.3c1.6-0.2,3.3-0.5,4.8-0.9C50.2,107.8,50,109.5,49.8,111.1z M55.1,99.8L30.8,75.5l12.8-12.8v9.5 c0,1.3,0.5,2.6,1.5,3.6l17,17L55.1,99.8z M69.4,85.6L53.9,70.1V56.3l11.8,11.8c1,1,2.3,1.5,3.6,1.5h16.1L69.4,85.6z M118.3,47.6 c-1.5,1.5-4.5,1.9-7.4,2.3c-1.6,0.2-3.3,0.5-4.8,0.9c0.4-1.5,0.7-3.2,0.9-4.8c0.4-2.9,0.8-5.9,2.3-7.4L122,25.9l9,9L118.3,47.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanoeSlalom);
export default __webpack_public_path__ + "static/media/canoeSlalom.1e4aa2d3ffee1f40df01a651ddfc861a.svg";
export { ForwardRef as ReactComponent };